// 출석 효과음 종류 관리. 구버전 네이티브 앱의 "효과음 변경"을 웹뷰로 이식 (localStorage 저장).

import mechanicalSound from "/public/voice/MathFLAT_Attendance_src_main_res_raw_sound_attend.wav";
import girlEnterSound from "/public/voice/MathFLAT_Attendance_src_main_res_raw_sound_attend_girl.wav";
import girlExitSound from "/public/voice/MathFLAT_Attendance_src_main_res_raw_sound_exit_girl.wav";

// MECHANICAL: 기계음(기본), GIRL: 사람 목소리
export type AttendSoundType = "MECHANICAL" | "GIRL";

type AttendStatus = "ENTER" | "QUIT";

const STORAGE_KEY = "attendSound";
const DEFAULT_SOUND_TYPE: AttendSoundType = "MECHANICAL";

export const soundPreference = {
  // 저장값이 없거나 알 수 없으면 기본값(기계음)
  get(): AttendSoundType {
    return localStorage.getItem(STORAGE_KEY) === "GIRL"
      ? "GIRL"
      : DEFAULT_SOUND_TYPE;
  },

  set(type: AttendSoundType): void {
    localStorage.setItem(STORAGE_KEY, type);
  },

  toggle(): AttendSoundType {
    const next: AttendSoundType =
      soundPreference.get() === "GIRL" ? "MECHANICAL" : "GIRL";
    soundPreference.set(next);
    return next;
  },

  getToggleLabel(): string {
    return soundPreference.get() === "GIRL"
      ? "기계음 소리로 효과음 변경"
      : "사람 목소리로 효과음 변경";
  },

  // 기계음은 입/퇴실 동일 음원, 사람 목소리는 분리
  getSoundSrc(status: AttendStatus): string {
    if (soundPreference.get() === "GIRL") {
      return status === "ENTER" ? girlEnterSound : girlExitSound;
    }
    return mechanicalSound;
  },
};
